module.exports = __webpack_public_path__ + "static/media/property-address.1585dc87.svg";